<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <!--Nuevo ADV-2351-->
            <div class="col-12">
                <div class="product-summary">
                <ng-container *ngIf="canExonerate">
                    <div class="py-4 py-md-0">
                        <label class="mb-0">
                            {{ 'product.convenience' | translate }}
                            <span class="appropriateness ml-4" [class.not-appropriateness]="!selectedProduct.isAppropriateness">
                                <mat-icon>check</mat-icon>
                            </span>
                        </label>
                    </div>
                    <div class="d-flex">
                        <label class="mt-1 mb-0 mt-md-0">{{ 'product.exonerate' | translate }}</label>
                        <mat-radio-group class="ml-4" [disabled]="true" *ngIf="selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                        <mat-radio-group class="ml-4" [disabled]="!editable" name="isExonerated" [(ngModel)]="selectedProduct.isExonerated" (ngModelChange)="onExonerate()" *ngIf="!selectedProduct.isAppropriateness">
                            <mat-radio-button color="blue-gray" [value]="false">
                                {{ 'general.no' | translate }}
                            </mat-radio-button>
                            <mat-radio-button class="ml-5" color="blue-gray" [value]="true">
                                {{ 'general.yes' | translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </ng-container>
                </div>
            </div>
            <!--Fin de Nuevo ADV-2351-->
            <div class="col-12">
                <h3 class="mat-title bg-blue px-3 mb-0">
                    {{ 'operative.fund-origin' | translate }}
                </h3>
                <div class="bg-gray p-3">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <mat-select
                                    name="manager"
                                    [placeholder]="'form.origin-entity' | translate"
                                    required
                                    [disabled]="!editable"
                                    [(ngModel)]="selectedProduct.order.externalTransferManager"
                                    #managerCtrl="ngModel"
                                >
                                    <mat-option *ngFor="let trader of traders" [value]="trader.id.value">
                                        {{ trader.name + ' (' + trader.nif + ')' + ' - ' + trader.cnmv }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="managerCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input
                                    name="name"
                                    matInput
                                    [placeholder]="'form.origin-investment-name' | translate"
                                    required
                                    [disabled]="!editable"
                                    [(ngModel)]="selectedProduct.order.externalTransferName"
                                    #nameCtrl="ngModel"
                                />
                                <mat-error *ngIf="nameCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input
                                    name="isin"
                                    matInput
                                    [placeholder]="'form.origin-isin' | translate"
                                    required
                                    maxlength="12"
                                    [disabled]="!editable"
                                    [(ngModel)]="selectedProduct.order.externalTransferISIN"
                                    isin
                                    #isinCtrl="ngModel"
                                />
                                <mat-error *ngIf="isinCtrl.hasError('isin') && !isinCtrl.hasError('required')">
                                    {{ 'form.validation.isin' | translate }}
                                </mat-error>
                                <mat-error *ngIf="isinCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input
                                    name="codeAccount"
                                    matInput
                                    [placeholder]="'form.origin-code-account' | translate"
                                    required
                                    [disabled]="!editable"
                                    [(ngModel)]="selectedProduct.order.externalTransferContract"
                                    #codeAccountCtrl="ngModel"
                                />
                                <mat-error *ngIf="codeAccountCtrl.hasError('required')">
                                    {{ 'form.validation.required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-label class="d-block text-blue mb-4">
                                {{ 'form.options-external-transfer' | translate }}
                            </mat-label>

                            <mat-radio-group
                                name="action"
                                [(ngModel)]="selectedProduct.order.action"
                                (ngModelChange)="onActionChange()"
                                [required]="true"
                                [disabled]="!editable"
                            >
                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-11 mb-4">
                                        <mat-radio-button class="d-block" name="actionTotal" color="blue-gray" [value]="OrderAction.TOTAL">
                                            {{ 'form.total' | translate }}
                                        </mat-radio-button>

                                        <div class="ml-4 ml-sm-5" *ngIf="selectedProduct.order.action === OrderAction.TOTAL">
                                            <mat-form-field
                                                class="full-width no-padding-bottom"
                                                [class.mat-form-field-invalid]="totalCtrl.invalid"
                                            >
                                                <mat-label>{{ 'form.amount-estimated' | translate }}</mat-label>
                                                <input
                                                    type="hidden"
                                                    name="amount"
                                                    [min]="minimumInvestment"
                                                    [(ngModel)]="selectedProduct.order.referenceAmount"
                                                    #totalCtrl="ngModel"
                                                />
                                                <input
                                                    matInput
                                                    #totalAutoNumericDirective="auto-numeric"
                                                    thr-auto-numeric
                                                    [placeholder]="'form.hints.amount' | translate"
                                                    required
                                                    [disabled]="!editable"
                                                    [value]="initialTotal"
                                                    (input)="onTotalChange()"
                                                />
                                            </mat-form-field>
                                            <div *ngIf="editable">
                                                <mat-hint class="d-block mat-caption" *ngIf="!totalCtrl.errors">
                                                    <ng-container *ngIf="!!minimumInvestmentMsg && minimumInvestment > 0">
                                                        {{
                                                            minimumInvestmentMsg
                                                                | translate
                                                                    : {
                                                                          value: minimumInvestment | number: '1.0-2'
                                                                      }
                                                        }}
                                                    </ng-container>
                                                </mat-hint>
                                                <mat-error
                                                    class="d-block mat-caption"
                                                    *ngIf="totalCtrl.hasError('min') && !totalCtrl.hasError('required')"
                                                >
                                                    <ng-container *ngIf="!!minimumInvestmentMsg">
                                                        {{
                                                            minimumInvestmentMsg
                                                                | translate
                                                                    : {
                                                                          value: minimumInvestment | number: '1.0-2'
                                                                      }
                                                        }}
                                                    </ng-container>
                                                </mat-error>
                                                <mat-error class="d-block mat-caption" *ngIf="totalCtrl.hasError('required')">
                                                    {{ 'form.validation.required' | translate }}
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-11 mb-4">
                                        <mat-radio-button
                                            class="d-block"
                                            name="actionShares"
                                            color="blue-gray"
                                            [value]="OrderAction.SHARES"
                                        >
                                            {{ 'form.number-shares' | translate }}
                                        </mat-radio-button>

                                        <div class="ml-4 ml-sm-5" *ngIf="selectedProduct.order.action === OrderAction.SHARES">
                                            <mat-form-field class="full-width">
                                                <input
                                                    type="hidden"
                                                    name="shares"
                                                    [min]="0.00000001"
                                                    [(ngModel)]="selectedProduct.order.shares"
                                                    #sharesCtrl="ngModel"
                                                />
                                                <input
                                                    matInput
                                                    #sharesDirective="auto-numeric"
                                                    thr-auto-numeric
                                                    [placeholder]="'form.indicates-number-shares' | translate"
                                                    [numDecimals]="8"
                                                    [currencySymbol]="''"
                                                    required
                                                    [disabled]="!editable"
                                                    [value]="initialShares"
                                                    (input)="onShareChange()"
                                                />
                                            </mat-form-field>
                                            <div *ngIf="editable">
                                                <mat-hint class="d-block mat-caption" *ngIf="!sharesCtrl.errors">
                                                    <ng-container *ngIf="!!minimumInvestmentMsg && minimumInvestment > 0">
                                                        {{
                                                            minimumInvestmentMsg
                                                                | translate
                                                                    : {
                                                                          value: minimumInvestment | number: '1.0-2'
                                                                      }
                                                        }}
                                                    </ng-container>
                                                </mat-hint>
                                                <mat-error
                                                    class="d-block mat-caption"
                                                    *ngIf="sharesCtrl.hasError('required') || sharesCtrl.hasError('min')"
                                                >
                                                    {{ 'form.validation.required' | translate }}
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row justify-content-center">
                                    <div class="col-12 col-md-11 mb-4">
                                        <mat-radio-button
                                            class="d-block"
                                            name="actionAmount"
                                            color="blue-gray"
                                            [value]="OrderAction.AMOUNT"
                                        >
                                            {{ 'form.for-amount' | translate }}
                                        </mat-radio-button>

                                        <div class="ml-4 ml-sm-5" *ngIf="selectedProduct.order.action === OrderAction.AMOUNT">
                                            <mat-form-field
                                                class="full-width no-padding-bottom"
                                                [class.mat-form-field-invalid]="amountCtrl.invalid"
                                            >
                                                <mat-label>{{ 'form.amount' | translate }}</mat-label>
                                                <input
                                                    type="hidden"
                                                    name="amount"
                                                    [min]="minimumInvestment"
                                                    [(ngModel)]="selectedProduct.order.amount"
                                                    #amountCtrl="ngModel"
                                                />
                                                <input
                                                    matInput
                                                    #amountDirective="auto-numeric"
                                                    thr-auto-numeric
                                                    [placeholder]="'form.hints.amount' | translate"
                                                    required
                                                    [disabled]="!editable"
                                                    [value]="initialAmount"
                                                    (input)="onAmountChange()"
                                                />
                                            </mat-form-field>
                                            <div *ngIf="editable">
                                                <mat-hint class="d-block mat-caption" *ngIf="!amountCtrl.errors">
                                                    <ng-container *ngIf="!!minimumInvestmentMsg && minimumInvestment > 0">
                                                        {{
                                                            minimumInvestmentMsg
                                                                | translate
                                                                    : {
                                                                          value: minimumInvestment | number: '1.0-2'
                                                                      }
                                                        }}
                                                    </ng-container>
                                                </mat-hint>
                                                <mat-error
                                                    class="d-block mat-caption"
                                                    *ngIf="amountCtrl.hasError('min') && !amountCtrl.hasError('required')"
                                                >
                                                    <ng-container *ngIf="!!minimumInvestmentMsg">
                                                        {{
                                                            minimumInvestmentMsg
                                                                | translate
                                                                    : {
                                                                          value: minimumInvestment | number: '1.0-2'
                                                                      }
                                                        }}
                                                    </ng-container>
                                                </mat-error>
                                                <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('required')">
                                                    {{ 'form.validation.required' | translate }}
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="full-width">
                                <mat-select
                                    name="trader"
                                    [placeholder]="'form.origin-trader' | translate"
                                    [disabled]="!editable"
                                    [(ngModel)]="selectedProduct.order.externalTransferTrader"
                                >
                                    <mat-option *ngFor="let trader of externalTraders" [value]="trader.id.value">
                                        {{ trader.name + ' (' + trader.nif + ')' }}
                                    </mat-option>
                                </mat-select>
                        </mat-form-field>
                        </div>
                    </div>
                </div>
                <h3 class="mat-title bg-blue px-3 mb-0">
                    {{ 'operative.fund-target' | translate }}
                </h3>
                <div class="bg-gray p-3">
                    <div class="row">
                        <div class="col-12">
                            <mat-form-field class="full-width mb-3 mb-sm-4">
                                <input
                                    name="nameFund"
                                    type="text"
                                    matInput
                                    [placeholder]="'form.name-of-fund' | translate"
                                    [disabled]="true"
                                    [ngModel]="product.name"
                                />
                            </mat-form-field>
                            <mat-form-field class="full-width">
                                <input
                                    name="targetEntity"
                                    type="text"
                                    matInput
                                    [placeholder]="'form.target-entity' | translate"
                                    [disabled]="true"
                                    [ngModel]="product.custodian"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
